import { render, staticRenderFns } from "./PefDiaryTable.vue?vue&type=template&id=ebb21128&"
import script from "./PefDiaryTable.vue?vue&type=script&lang=js&"
export * from "./PefDiaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports